import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Simran
 * id 41B86B22-7245-4A97-9BAA-3E9EBD44CEB0
 * name wifi-strength-4
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/wifi-strength-4.svg
 * tags
 */
export const WifiStrength4Icon = createSvgIcon(<><path d="M12,3C7.79,3 3.7,4.41 0.38,7C4.41,12.06 7.89,16.37 12,21.5C16.08,16.42 20.24,11.24 23.65,7C20.32,4.41 16.22,3 12,3Z" /></>, 'WifiStrength4Icon');
export default WifiStrength4Icon